import React, {Component} from 'react';

import '../../sass/headers/header.scss';

import {t} from 'l10n';

class HeaderIndex extends Component
{
    constructor(props) {
        super(props);
        
        let {currentUser} = props;
        
        this.state = {
            logged_in: this.isLoggedIn(currentUser)
        }
    }

    isLoggedIn(currentUser) {
        return currentUser && currentUser.isLoggedIn();
    }
    
    render()
    {
        let {currentUser} = this.props;

        if(this.isLoggedIn(currentUser)) {
            return (
                <header className="logged-in">
                    <div></div>
                </header>
            )
        } else {
            return (
                <header className="index">
                    <div className="content">
                        <div className="padding">
                            <h1 dangerouslySetInnerHTML={{__html: t('BobTV is the site of stripping in webcam chat of <a href="http://www.bobvoyeur.com/" target="_blank">Bob Voyeur</a>')}}/>
                            <p className="text" dangerouslySetInnerHTML={{__html: t('Stripping of couples making sex in front of their webcam. Free naughty dating and strip-tease by video cam. For stripping among adult amateurs, naughties and sluts. To discover swinging, debauchery or flirting voyeurs')}}/>
                        </div>
                    </div>
                </header>
            )
        }
    }
}

export default HeaderIndex;




// WEBPACK FOOTER //
// ./src/components/index/HeaderIndex.js